import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Audience, AudienceComment } from 'src/app/models/services/audience';
import { AudiencesService } from 'src/app/services/audiences/audiences.service';
import { DialogService } from 'src/app/services/core/dialog.service';
import { TextAreaFieldDialogService } from 'src/app/services/core/text-area-field-dialog.service';

@Component({
  selector: 'audience-comments-block',
  templateUrl: './audience-comments-block.component.html',
  styleUrls: ['./audience-comments-block.component.sass']
})
export class AudienceCommentsBlockComponent implements OnInit {

  @Input()
  audience: Audience;

  @Output() 
  onCommentAdded = new EventEmitter<Audience>();

  constructor(
    private audiencesService: AudiencesService,
    private textAreaFieldDialogService: TextAreaFieldDialogService,
    private spinnerService: NgxSpinnerService,
    private dialogService: DialogService
  ) {

  }

  ngOnInit(): void {
  }

  addComment = (): void => {
    this.textAreaFieldDialogService.show(
      'Add comment',
      'Comment',
      `Add the following comment to the audience.`,
      (comment: string) => {
        this.spinnerService.show();
        this.audiencesService.addComment(this.audience.id, {
          audienceId: this.audience.id,
          comment: comment
        }).subscribe(
          () => {
            this.spinnerService.hide();
            this.onCommentAdded.emit(this.audience);
            this.dialogService.showMessage("Audience tags", "Tags created / updated successfully");
          },
          () => { this.spinnerService.hide(); }
        );
      },
      () => { }
    );
  }

  deleteComment = (comment: AudienceComment): void => {
    this.dialogService.showConfirmation('Are you sure to remove comment?', 
      () => {
        this.audiencesService.removeComment(comment.audienceId, comment.id).subscribe(
          () => {
            let commentIndex: number = this.audience?.comments?.findIndex(x => x.id == comment.id);
            this.audience?.comments?.splice(commentIndex, 1);
          });
      },
      () => { });
  }  

}
